export default __webpack_public_path__ + "static/char-thumb-36-3abf2d91d7128b978c0b19770452216e.png";